// 状态管理
'use strict'

import Vue    from 'vue'
import Vuex   from 'vuex'
import { mutation } from './utils/vuexUtil'

// import modules
import demo from './modules/demo'
import user from './modules/user'
import common from './modules/common'

Vue.use(Vuex)

let state = {}
let mutations = mutation(state, {})
let store = new Vuex.Store({
    state: state,
    mutations: mutations,
    getters: {},
    actions: {},
    modules: {
        demo,
        user,
        common
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js